import { useEffect } from 'react';
import type { RemitReportingEntrypoint } from 'src/apis/remit-reporting/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleError } from 'src/utils/handle-error';
import { reportToSentry } from 'src/utils/report-to-sentry';

export function useRemitReportingEntrypoint() {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<RemitReportingEntrypoint>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.remitReporting}/api/platform/entrypoint`,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: false,
      cacheKey: 'RemitReportingEntrypoint',
      onError(error) {
        const [_, report] = handleError(error, () => {});
        if (report) reportToSentry(error);
        return error;
      },
    }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type RemitReportingEntrypointRequest = ReturnType<
  typeof useRemitReportingEntrypoint
>;
